import { GoldOutlined, TeamOutlined, EnvironmentOutlined } from '@ant-design/icons'

export const OVERRIDE_TYPE_CONFIG = {
  vendorLocation: {
    title: 'Vendor Location Overrides',
    icon: GoldOutlined,
    description: 'Manage fee and due date overrides for specific vendors at specific locations',
  },
  vendor: {
    title: 'Vendor Overrides',
    icon: TeamOutlined,
    description: 'Manage fee and due date overrides for specific vendors',
  },
  location: {
    title: 'Location Overrides',
    icon: EnvironmentOutlined,
    description: 'Manage fee and due date overrides for specific locations',
  },
}
